import { Col, Row } from 'antd';
import React, { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { ProjectId } from 'api/models';
import { LinkButton } from 'components/atoms/button';
import { ShowForCustomer } from 'components/atoms/user-type-utils';
import { PlaceholderResolution } from 'components/molecules/project-details/header/placeholder-resolution';
import { GlobalInviteModal } from 'components/organisms/projects/global-invite/modal/modal';
import { TabbedMemberList } from 'components/organisms/projects/global-invite/tabbed-member-list';
import { useProjectDetail } from 'data/projects/hooks';
import { ResponsiveCard } from '../../style';

const Wrapper = styled.div`
  margin-right: var(--spacing-05);
`;
const Card = styled(ResponsiveCard)`
  max-height: 520px;
  height: 520px;
`;
const MemberList = styled(TabbedMemberList)`
  height: 448px;
`;

export const ProjectOverviewTeamMembersCard: FC<{ projectId: number }> = ({
  projectId,
}) => {
  const [showInvitePopup, setShowInvitePopup] = useState(false);
  const { data: project, isLoading } = useProjectDetail(ProjectId(projectId));

  return (
    <Card
      title={
        <Row>
          <Col flex={1}>
            <strong>
              <FormattedMessage id="team_members" />
            </strong>
          </Col>
          <ShowForCustomer>
            {project != null ? (
              <Wrapper>
                <PlaceholderResolution project={project} />
              </Wrapper>
            ) : null}
          </ShowForCustomer>
          <LinkButton
            loading={isLoading}
            onClick={() => setShowInvitePopup(true)}
          >
            <FormattedMessage id="invite" />
          </LinkButton>
        </Row>
      }
    >
      {project ? <MemberList readOnly project={project} /> : null}

      {showInvitePopup && (
        <GlobalInviteModal
          visible={showInvitePopup}
          handleOnClose={setShowInvitePopup}
          projectId={projectId}
        />
      )}
    </Card>
  );
};
